// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sjraa","clinicsSelect":"styles_clinicsSelect__zC4td"};